import { useActiveModals } from 'entities/application';
import { useIsAutorizedUser } from 'store/features/auth/selectors';
import { useIsClient } from 'store/features/auth/selectors/user';
import { useShowStreetView } from 'entities/map';

import {
  isEastTerritory,
  isFrameUser
} from 'common/utils';

export const useShowNavigationHistoryButton = () => {
  const isAutorizedUser = useIsAutorizedUser();
  const isClient = useIsClient();
  const showStreetView = useShowStreetView();
  const {
    showNavigationHistoryFilter,
    showRoute
  } = useActiveModals();

  return {
    here: !(isEastTerritory || isFrameUser || (isAutorizedUser && !isClient) || showStreetView),
    google: !(isEastTerritory || showNavigationHistoryFilter || showRoute || isFrameUser || (isAutorizedUser && !isClient) || showStreetView)
  };
};
